import React, { useState } from "react";
import fallBackImage from '../Assests/images/placeholderimage.jpg'
import DeleteModal from "./DeleteModal";
import { applicationService } from "../services/applicationService";
import toast from "react-hot-toast";

export default function ManageEducatoresUser({ userRole, educators, loader, getApplicationDetail, decryptId }) {
    const [selectedEducatorId, setSelectedEducatorId] = useState('')
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false)

    const handleDelete = async () => {
        try {
            setDeleteLoader(true)
            let data = JSON.stringify({
                'applicationId': decryptId,
                'educator_id': selectedEducatorId.toString(),
                'student_id': null,
            })
            let response = await applicationService.removeEducatorAndStudentFromAppDetails(data)
            if (response?.success == true) {
                setDeleteLoader(false)
                toast.success(response?.message || 'Educator removed successfully')
                setIsDeleteOpen(false)
                setSelectedEducatorId('')
                await getApplicationDetail()
            } else {
                setDeleteLoader(false)
                setSelectedEducatorId('')
                setIsDeleteOpen(false)
            }
        } catch (e) {
            setDeleteLoader(false)
            setSelectedEducatorId('')
            setIsDeleteOpen(false)
            toast.error(e.response.data.message || 'Something went wrong')
        }
    }
    return (
        <div className="bg-white rounded-2xl shadow p-4 w-full h-[414px] overflow-y-auto scrollbar-hide">
            {/* Header */}


            {/* List */}
            <ul className="space-y-4 p-2">
                {loader ?
                    <div className="h-[330px] flex items-center justify-center">
                        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
                    </div>
                    :
                    (educators && educators.length > 0) ? educators.map((edu, index) => (
                        <li
                            key={index}
                            className="flex justify-between items-center p-2"
                        >
                            <div className="flex items-center gap-3">
                                <img
                                    src={edu?.profile_pic || fallBackImage}
                                    alt={edu?.full_name}
                                    className="w-10 h-10 rounded-full object-cover"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = fallBackImage;
                                    }}
                                />
                                <div>
                                    <p className="text-gray-800 font-medium">{edu?.full_name}</p>
                                    <p
                                        className={`text-sm ${edu?.is_active === 1
                                            ? "text-green-600"
                                            : "text-gray-500"
                                            }`}
                                    >
                                        {edu?.is_active == 1 ? 'Active' : 'In-active'}
                                    </p>
                                </div>
                            </div>
                            {userRole?.role_name == 'Admin' &&
                                <button className="bg-gray-100 px-4 py-1 rounded-lg text-gray-600 text-sm font-medium hover:bg-gray-200" onClick={() => { setIsDeleteOpen(true); setSelectedEducatorId(edu?.user_id) }}>
                                    Remove
                                </button>
                            }
                        </li>
                    )) :
                        <div className="text-center h-[350px] content-center">
                            <p className="text-gray-400 text-sl">There are currently no educator.</p>
                        </div>
                }
            </ul>
            <DeleteModal
                isOpen={isDeleteOpen}
                onClose={() => { setIsDeleteOpen(false); setSelectedEducatorId('') }}
                onConfirm={handleDelete}
                title='Remove'
                deleteLoader={deleteLoader}
            />
        </div>
    );
}